import type { IValidationErrorDto, IValidatorObject, IValidatorResult } from "@/types/FormEngine/validation";
import { defineComponent } from "vue";
import { t } from "@/services/Translation/t";
import { isTreeSection } from "@/helpers/Misc";

export default defineComponent({
  components: {},
  name: "ErrorBag",
  props: {},
  data() {
    return {
      state: {
        currentErrors: new Array<IValidationErrorDto>(),
        title: t("title", "_errorBag"),
        subtitle: t("subtitle", "_errorBag"),
      },
    };
  },
  created() {
    window.FormEngine.form.registerErrorBag(this);
  },
  computed: {
    displayedErrors() {
      return this.state.currentErrors;
    },
    currentUrl() {
      return window.location.href.split("#")[0];
      //return window.location.href;
    },
  },
  methods: {
    t, // Translation
    refreshErrors() {
      let refreshingErrors = this.state.currentErrors.map((err) => err.targetId);
      for (let err of refreshingErrors) {
        let control = window.FormEngine.form.controls.get(err);
        if (control) {
          control.validate();
        } else {
          window.FormEngine.form.validation.validate(window.FormEngine.form.validation.createNewValidationDto(err));
        }
      }
    },
    pushErrors(errors: [IValidationErrorDto]) {
      if (errors.length > 0) {
        for (let err of errors) {
          this.pushError(err);
        }
      } else {
        this.resetErrors();
      }
    },
    pushError(error: IValidationErrorDto) {
      let tempErrorIndex = this.state.currentErrors.findIndex((validationErrorDto) => {
        return (
          validationErrorDto.targetId == error.targetId &&
          validationErrorDto.validatorGuid == error.validatorGuid &&
          validationErrorDto.navigationData == error.navigationData
        );
      });

      //console.log(error);
      if (tempErrorIndex === -1) {
        //console.log("JSUT A PUSH",error,this.state.currentErrors);
        if (error.control) {
          if (!error.control.state.hidden) {
            this.state.currentErrors.push(error);
          }
        } else {
          this.state.currentErrors.push(error);
        }
      } else {
        //console.log("SLICE AND PUSH", error, this.state.currentErrors[tempErrorIndex]);
        this.state.currentErrors.splice(tempErrorIndex, 1);
        this.state.currentErrors.push(error);
      }
    },

    removeErrorByGuid(validatorGuid: string, controlId?: string) {
      let tempErrors = this.state.currentErrors.filter(function (item) {
        return item.validatorGuid === validatorGuid;
      });
      let control = null;
      if (tempErrors && tempErrors.length > 0) {
        for (let tempErrorIndex in tempErrors) {
          if (this.state.currentErrors[tempErrorIndex] && this.state.currentErrors[tempErrorIndex].control) {
            control = this.state.currentErrors[tempErrorIndex].control;
          }
          this.state.currentErrors.splice(parseInt(tempErrorIndex), 1);
        }
      }
      if (!control && controlId) {
        control = window.FormEngine.form.controls.get(controlId);
      }
      if (control) {
        control.removeError(validatorGuid);
      }
    },

    removeError(result: IValidatorResult, fillErrorBag: boolean = true, fillControlErrors: boolean = true) {
      let tempErrorIndex = this.state.currentErrors.findIndex(function (item) {
        return item.targetId == result.targetId && item.navigationData == result.navigationData && item.validatorGuid == result.validatorGuid;
      });
      if (tempErrorIndex !== -1) {
        if (this.state.currentErrors[tempErrorIndex] && this.state.currentErrors[tempErrorIndex].control) {
          this.state.currentErrors[tempErrorIndex].control.removeError(result);
        }
        this.state.currentErrors.splice(tempErrorIndex, 1);
      }
    },
    removeErrors(validableId: string) {
      for (let errKey in this.state.currentErrors) {
        if (
          this.state.currentErrors[errKey].targetId == validableId ||
          (this.state.currentErrors[errKey].navigationData && JSON.stringify(this.state.currentErrors[errKey].navigationData).includes(validableId))
        ) {
          this.state.currentErrors.splice(parseInt(errKey), 1);
        }
      }
    },
    removeErrorsByRowGuid(rowGuid: string) {
      let currErr = this.state.currentErrors.filter((err) => {
        if (err.navigationData) {
          let navData = JSON.parse(err.navigationData);
          let navShard = navData.pop();
          if (navShard) {
            return navShard.rowGuid === rowGuid;
          } else {
            return true;
          }
        }
        return true;
      });
      this.state.currentErrors = currErr;
    },
    resetErrors() {
      for (let err of this.state.currentErrors) {
        if (err.control) {
          err.control.resetErrors(err);
        }
      }
      this.state.currentErrors = [];
    },
    navigateToTarget(error: IValidationErrorDto) {
      //console.log(error);
      if (error.navigationData) {
        let navData = JSON.parse(error.navigationData);
        for (let navStep of navData) {
          console.log(navStep);

          let tempC = window.FormEngine.form.sections.get(navStep.identifier);
          if (!tempC) {
            tempC = window.FormEngine.form.controls.get(navStep.identifier);
            if (tempC.mtdt.IsTable) {
              //console.log(navStep);
              if (navStep.openedRow) {
                tempC.openDetailViewRowNumber(navStep.openedRow);
              }
            }
            let parentTarget = window.FormEngine.form.getTargetable(tempC.mtdt.Parent);
            if (isTreeSection(parentTarget.mtdt)) {
              parentTarget.openAccordionTab();
            }
          } else {
            tempC.openAccordionTab();
          }
        }
      }
      // TODO: remove navigational hashtag in url ?
    },
  },
});
